import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  Button,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import Card from "../../components/Cards/Card";
import styled from "styled-components";
import NativeObject from "../../components/NativeObject/NativeObject";
import { useSelections } from "../../context/Selections";
import DetalheRanking from "./DetalheRanking/DetalheRanking";

import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";

import gestaodainfo from "../../assets/icons/gestaodainfo.svg";

const LayoutCardWrapper = styled.div`
  border-radius: 16px;
  display: flex;
  width: 100%;
  height: 100%;
  padding-right: 10px;
`;

const LayoutCardsWrapper = styled("div")({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  height: "95%",
  justifyContent: "flex-start",
  width: "100%",
});

function RankingDesktop({ app, config }) {
  const [selectedValue, setSelectedValue] = useState("TOP 10 PDVs");
  const [selectedValueExpandido, setSelectedValueExpandido] =
    useState("TOP 10 PDVs Exp");
  const [tableSee, setTableSee] = useState(false);
  const [userChanged, setUserChanged] = useState(false); // Flag para verificar se o valor foi alterado pelo usuário
  const { selections } = useSelections();

  const [detail, setDetail] = useState("");

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
    setUserChanged(true); // Marcar que o usuário alterou o valor
    setTableSee(false);
    app.field("Tipo_PDV").selectMatch(event.target.value, true);
  };

  const handleClick = () => {
    if (selectedValue === "TOP 10 PDVs") {
      app.field("Tipo_PDV").selectMatch("TOP 10 PDVs Exp", true);
      setSelectedValueExpandido("TOP 10 PDVs Exp");
      setTableSee(true);
    } else {
      app.field("Tipo_PDV").selectMatch("TOP 20 PDVs Exp", true);
      setSelectedValueExpandido("TOP 20 PDVs Exp");
      setTableSee(true);
    }

    if (tableSee && selectedValueExpandido === "TOP 10 PDVs Exp") {
      setTableSee(false);
      app.field("Tipo_PDV").selectMatch("TOP 10 PDVs", true);
    } else if (tableSee && selectedValueExpandido === "TOP 20 PDVs Exp") {
      setTableSee(false);
      app.field("Tipo_PDV").selectMatch("TOP 20 PDVs", true);
    }
  };

  async function detailSelecao() {
    await app.variable.getContent("vSelecao_Mix", (reply) => {
      const data = reply.qContent.qString;
      setDetail(data.substring(0, 15));
    });
  }

  useEffect(() => {
    detailSelecao();
  }, [selections]);

  useEffect(() => {
    if (app) {
      // Verifica se o valor não foi alterado pelo usuário
      const distributors = selections?.length
        ? selections.find((s) => s.qField === "Tipo_PDV")
        : null;

      if (
        distributors?.qSelected === "TOP 10 PDVs" ||
        distributors?.qSelected === "TOP 20 PDVs"
      ) {
        setSelectedValue(distributors?.qSelected); // Atualiza com o valor da API
      }

      if (distributors?.qSelected === "TOP 10 PDVs Exp") {
        setSelectedValue("TOP 10 PDVs");
        setTableSee(true);
      }
      if (distributors?.qSelected === "TOP 20 PDVs Exp") {
        setSelectedValue("TOP 20 PDVs");
        setTableSee(true);
      }
    }
  }, [app, selections, userChanged]);

  return (
    <div className="app ranking">
      <div className="appContent">
        <FormControl className="container-form-control">
          <RadioGroup
            row
            defaultValue={selectedValue | selectedValueExpandido}
            name="row-radio-buttons-group"
            className="radio-group radio-group-button-export"
            value={selectedValue}
            onChange={handleChange}
            sx={{ marginLeft: "20px" }}
          >
            <FormControlLabel
              value="TOP 10 PDVs"
              control={
                <Radio
                  size="small"
                  sx={{
                    color: "#0DA9D5",
                    "&.Mui-checked": {
                      color: "#0DA9D5",
                    },
                  }}
                />
              }
              label="TOP 10 PDVs"
            />

            <FormControlLabel
              value="TOP 20 PDVs"
              control={
                <Radio
                  size="small"
                  sx={{
                    color: "#0DA9D5",
                    "&.Mui-checked": {
                      color: "#0DA9D5",
                    },
                  }}
                />
              }
              label="TOP 20 PDVs"
            />
          </RadioGroup>
        </FormControl>

        <LayoutCardsWrapper>
          <LayoutCardWrapper>
            <div className="group-cards">
              <div style={{ width: "100%", height: "90%" }}>
                <Card
                  app={app}
                  style={{
                    width: "100%",
                    height: "100%",
                  }}
                  exportContainer
                  exportTable
                  exportTableId="jPRfv"
                >
                  <div className="container-toogle-see">
                    <Button
                      variant="text"
                      startIcon={
                        tableSee ? (
                          <VisibilityOutlinedIcon size={13} />
                        ) : (
                          <VisibilityOffOutlinedIcon size={13} />
                        )
                      }
                      onClick={handleClick}
                    >
                      {tableSee ? "Fechar" : "Expandir"}
                    </Button>
                  </div>
                  <NativeObject
                    app={app}
                    key="jPRfv"
                    reference={{ id: "jPRfv" }}
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                  />
                </Card>
                {detail === "1" && <DetalheRanking app={app} config={config} />}
              </div>
            </div>
          </LayoutCardWrapper>
        </LayoutCardsWrapper>
      </div>
    </div>
  );
}

RankingDesktop.defaultProps = {
  app: null,
  config: {},
};

RankingDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default RankingDesktop;
